import React from 'react';
export function Footer() {
  return <footer className="relative z-10 mt-24 border-t border-white/[0.06]" data-id="element-7">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center space-y-6" data-id="element-8">
        <p className="font-heading text-sm text-[#aaaaaa] tracking-widest uppercase" data-id="element-9">
          Peptide Science Institute - A Division of the Institute of Scientific
          Augmentation
        </p>

        <p className="font-heading text-xs text-[#888888] leading-relaxed max-w-2xl mx-auto" data-id="element-10">
          MEDICAL DISCLAIMER: The information on this site is for informational
          and educational purposes only, does not constitute medical advice, and
          does not establish any kind of patient-client relationship by the use
          of this website.
        </p>

        <p className="font-heading text-sm text-[#aaaaaa] tracking-widest uppercase" data-id="element-11">
          Copyright © Institute of Scientific Augmentation |{' '}
          <a href="https://peptidescienceinstitute.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200" data-id="element-12">
            Privacy Policy
          </a>{' '}
          |{' '}
          <a href="https://peptidescienceinstitute.com/terms-of-use" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200" data-id="element-13">
            Terms of Use
          </a>
        </p>
      </div>
    </footer>;
}